// extracted by mini-css-extract-plugin
export default {"BaseHeading":"CategoryHeading__BaseHeading__Qk3J8","CategoryHeading":"CategoryHeading__CategoryHeading__D0AAA"};